import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import React from "react";

export function useAutofocus(
  ref: React.RefObject<HTMLTextAreaElement>,
  options?: Partial<{ hideKeyboard: boolean; timeout: number }>
) {
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (ref.current === null) {
        return;
      }

      ref.current.focus();

      if (options?.hideKeyboard === true && Capacitor.isPluginAvailable("Keyboard")) {
        Keyboard.hide();
      }
    }, options?.timeout ?? 400);

    return () => clearTimeout(timeout);
  }, [options?.hideKeyboard, options?.timeout, ref]);
}
